import { Component, Inject } from "@angular/core";

import {
    DEFAULT_MEDIA_QUERIES_OPTIONS,
    MediaQueryOption,
} from "@hermes/aphrodite/media-picture";
import {
    PushCategoryPosterDeprecated,
    TOKEN_TYPE,
    ImageDeprecated,
} from "@hermes/api-model-editorial";

import { CHAPTERS_PARAGRAPH, SHOULD_PRELOAD_MEDIA } from "../../core";

import { CategoryPosterAnalyticsService } from "./category-poster-analytics.service";

@Component({
    selector: "h-category-poster",
    templateUrl: "./category-poster.component.html",
    styleUrls: ["./category-poster.component.scss"],
})
export class CategoryPosterComponent {
    public mediaOptions: MediaQueryOption[] = DEFAULT_MEDIA_QUERIES_OPTIONS;

    constructor(
        @Inject(CHAPTERS_PARAGRAPH)
        public categoryPoster: PushCategoryPosterDeprecated,
        @Inject(SHOULD_PRELOAD_MEDIA) public shouldPreloadMedia: boolean,
        public categoryPosterAnalyticsService: CategoryPosterAnalyticsService,
    ) {}

    public setCTA(link: ImageDeprecated) {
        if (
            link.imageCta &&
            link.imageCta.tokenType !== TOKEN_TYPE.ctaMissing
        ) {
            return link.imageCta.path;
        }
        return undefined;
    }

    /**
     * Calculate the position of the element clicked in the category poster
     * if there is 2 lines with 3 and 5 elements respectively and we clicked the first element of
     * line 3, the position of the element should be 9
     *
     * @param lineIndex line index of the clicked element
     * @param itemIndex index position of the element inside the line
     **/
    public getElementPosition(lineIndex: number, itemIndex: number) {
        let length = 0;
        for (let index = 0; index < lineIndex; index++) {
            length =
                length + this.categoryPoster.imageLines[index].images.length;
        }
        return length + (itemIndex + 1);
    }

    public sendAnalyticsEvent(
        lineIndex: number,
        itemIndex: number,
        image: ImageDeprecated,
    ): void {
        // if no redirection (cta) no need to send this event
        if (
            image.imageCta &&
            image.imageCta.tokenType !== TOKEN_TYPE.ctaMissing
        ) {
            this.categoryPosterAnalyticsService.sendUAEvent({
                eventaction: `${this.getElementPosition(
                    lineIndex,
                    itemIndex,
                )} | ${image.title}`,
                eventlabel: image.imageCta.path,
            });
        }
    }

    public trackBySize(_index: number, mediaQueryOptions: MediaQueryOption) {
        return mediaQueryOptions.size;
    }
}
